import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toggleGuestMode} from '../../../actions/index';

class SwitchGuestMode extends Component {

    render() {
        const { guestMode, dispatch, hideToggle } = this.props;

        if ( !guestMode || hideToggle ) return null;

        return (
            <div className="mode-switch">
                <span>Preview mode</span>
                <button className={`btn-toggle${ guestMode ? ' toggle-on' : ' toggle-off'}`}
                        onClick={ () => dispatch(toggleGuestMode(false)) }>
                    { guestMode ? 'on' : 'off' }
                    <span className="dot"> </span>
                </button>
            </div>
        )
    }
}

export default connect()(SwitchGuestMode);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/SwitchGuestMode.js